import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { SubscriptionsFilter } from "./subscriptions-filter/SubscriptionsFilter";
import { SubscriptionsTable } from "./subscriptions-table/SubscriptionsTable";
import { useSubheader } from "../../../../../_metronic/layout";

export function SubscriptionsCard() {
  const navigate = useNavigate();
  const location = useLocation();
  const subheader = useSubheader();
  subheader.setTitle("Subscription");

  const pathSegment = location.pathname.split("/")[2] || "all";

  const isAll = pathSegment === "all" || !pathSegment;
  const isApproved = pathSegment === "approved";
  const isUnApproved = pathSegment === "un-approved";

  const callFilterFunction = (val) => {
    if (val === "all") { navigate(`/subscription/`); }
    if (val === "approved") { navigate(`/subscription/approved`); }
    if (val === "un-approved") { navigate(`/subscription/un-approved`); }
  };

  return (
    <Card>
      <CardHeader title="Subscription List">
        <CardHeaderToolbar />
      </CardHeader>
      <CardBody>
        <SubscriptionsFilter />
        <ul className="nav nav-tabs nav-tabs-line nav-tabs-pill mb-4" role="tablist">
          <li className="nav-item">
            <a
              href="/subscription/"
              onClick={(e) => { e.preventDefault(); callFilterFunction("all"); }}
              className={`nav-link ${isAll ? "active" : ""}`}
              data-toggle="tab"
              role="tab"
              aria-selected={isAll.toString()}
            >
              All 
            </a>
          </li>
          <li className="nav-item">
            <a
              href="/subscription/approved"
              onClick={(e) => { e.preventDefault(); callFilterFunction("approved"); }}
              className={`nav-link ${isApproved ? "active" : ""}`}
              data-toggle="tab"
              role="tab"
              aria-selected={isApproved.toString()}
            >
              Approved 
            </a>
          </li>
          <li className="nav-item">
            <a
              href="/subscription/un-approved"
              onClick={(e) => { e.preventDefault(); callFilterFunction("un-approved"); }}
              className={`nav-link ${isUnApproved ? "active" : ""}`}
              data-toggle="tab"
              role="tab"
              aria-selected={isUnApproved.toString()}
            >
              Invalid (Un-approved)
            </a>
          </li>
        </ul>
          
        <SubscriptionsTable />
      </CardBody>
    </Card>
  );
}
